import React, { useState } from 'react';
import { Toolbar, AppBar, Typography, Button } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { white } from '../../../app/theme';
import ExternalLinkModal from '../ExternalLinkModal/ExternalLinkModal';
import history from '../../../services/browserHistory';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    boxShadow: 'none',
    backgroundColor: theme.palette.lightBlueBackground?.main,
    height: 70,
  },
  topToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  healthcare: {
    fontSize: 16,
    paddingLeft: 41,
    color: white,
  },
  textLinkButtons: {
    color: '#fff',
    textTransform: 'none',
    marginRight: 32,
  },
}));

const HomeFooter = (): JSX.Element => {
  const classes = useStyles();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalUrl, setModalUrl] = useState<string>('');
  const shouldShowMLR = history.location.pathname === '/';

  const handleClickPrivacy = () => {
    setModalUrl('https://www.blueearthdiagnostics.com/privacy-policy/');
    setIsModalOpen(true);
  };
  const handleClickBlueEarthDiagnostics = () => {
    setModalUrl('http://blueearthdiagnostics.com/');
    setIsModalOpen(true);
  };
  const handleClickContactUs = () => {
    // TODO: When not logged in, this should display a different modal (CAX-78)
    setModalUrl('https://www.blueearthdiagnostics.com/contact/');
    setIsModalOpen(true);
  };

  return (
    <AppBar className={classes.root} position="static">
      <Toolbar className={classes.topToolbar}>
        <div>
          <Typography className={classes.healthcare}>
            &copy;2023 Blue Earth Diagnostics, Inc. All rights reserved.
          </Typography>
          {shouldShowMLR && <Typography className={classes.healthcare}>MLR22-005</Typography>}
        </div>
        <div>
          <Button className={classes.textLinkButtons} onClick={handleClickPrivacy}>
            Privacy
          </Button>
          <Button className={classes.textLinkButtons} onClick={handleClickBlueEarthDiagnostics}>
            BlueEarthDiagnostics.com
          </Button>
          <Button className={classes.textLinkButtons} onClick={handleClickContactUs}>
            Contact Us
          </Button>
        </div>
      </Toolbar>
      <ExternalLinkModal
        url={modalUrl}
        isOpen={isModalOpen}
        handleModalOpen={(isOpen: boolean) => setIsModalOpen(isOpen)}
      />
    </AppBar>
  );
};

export default HomeFooter;
